// Load the wallet for the user depending on the userId.
import firebase from "../../../components/Firebase.js";

export default async function LoadWalletForUser(userId) {
  // If there is not userId then fail the function.
  if (!userId) return null;

  const database = firebase.firestore();
  const walletDoc = await database
    .collection("CommunityWallets")
    .doc(userId)
    .get();
  // If the wallet doesn't exist create a new one.
  if (!walletDoc.exists) {
    return { userId, Total: 0, transactionHistory: [] };
  }
  // Pull the wallet data into a variable that is returned.
  const data = walletDoc.data();
  return { ...data };
}
